import Vue from 'vue'
import Vuelidate from 'vuelidate'
import VueMeta from 'vue-meta'
import appboy from 'appboy-web-sdk'
import App from './App.vue'
import router from './router'
import components from './components'
import store from './store'
import i18n from './i18n'
import faster from './faster'
import config from './config'
import smoothscroll from 'smoothscroll-polyfill'
import './registerServiceWorker'
import './js/fullscreenPolyfill'
import 'normalize.css'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

Vue.config.productionTip = false
Vue.use(components)
Vue.use(Vuelidate)
Vue.use(VueMeta, { refreshOnceOnNavigation: true })

smoothscroll.polyfill()

appboy.initialize(config.brazeApiKey)
faster.start()

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
